import LineBagIcon from 'LuxKit/Icons/line/LineBagIcon'
import LineBagSlashIcon from 'LuxKit/Icons/line/LineBagSlashIcon'
import LineLuggageIcon from 'LuxKit/Icons/line/LineLuggageIcon'
import LineLuggageSlashIcon from 'LuxKit/Icons/line/LineLuggageSlashIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { useIntl } from 'react-intl'

interface Props {
  carryOnIncluded?: boolean
  checkedBaggageIncluded?: boolean
  showCheckedBaggage?: boolean
}

function FareFamilyFlightTileV2Baggage(props: Props) {
  const {
    carryOnIncluded,
    checkedBaggageIncluded,
    showCheckedBaggage = true,
  } = props

  const intl = useIntl()

  const carryOnLabel = intl.formatMessage({
    id: 's3vzZzSn_wbWZQBRfs6V',
    defaultMessage: 'Carry-on',
    description: 'Label indicating carry-on baggage is included in flight fare',
  })

  const noCarryOnLabel = intl.formatMessage({
    id: 'XGc1F79768041NSIwEcA',
    defaultMessage: 'No carry-on',
    description: 'Label indicating carry-on baggage is not included in flight fare',
  })

  const checkedBagLabel = intl.formatMessage({
    id: 'kxZtcahJ2tAn2awFzfd3',
    defaultMessage: 'Checked bag',
    description: 'Label indicating checked baggage is included in flight fare',
  })

  const noCheckedBagLabel = intl.formatMessage({
    id: 'hLVsQacvHplODDdcY5Av',
    defaultMessage: 'No checked bag',
    description: 'Label indicating checked baggage is not included in flight fare',
  })

  return (
    <>
      <CaptionTextBlock
        variant="medium"
        startIcon={
          carryOnIncluded ? (
            <LineBagIcon colour="highlight-secondary" />
          ) : (
            <LineBagSlashIcon />
          )
        }
      >
        {carryOnIncluded ? carryOnLabel : noCarryOnLabel}
      </CaptionTextBlock>

      {showCheckedBaggage && <CaptionTextBlock
        variant="medium"
        startIcon={
          checkedBaggageIncluded ? (
            <LineLuggageIcon colour="highlight-secondary" />
          ) : (
            <LineLuggageSlashIcon />
          )
        }
      >
        {checkedBaggageIncluded ? checkedBagLabel : noCheckedBagLabel}
      </CaptionTextBlock>}
    </>
  )
}

export default FareFamilyFlightTileV2Baggage
